import api from './api/api';

export const getMySketch = async () => api.get('/environmental-licenses/my-sketch').then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const uploadDocument = async (environmentalLicense, document) => api.postForm(`/environmental-licenses/${environmentalLicense.id}/document`, { file: document }).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const deleteDocument = async (environmentalLicense, documentId) => api.delete(`/environmental-licenses/${environmentalLicense.id}/document/${documentId}`).then((response) => {
  if (response.status === 204) return response.data;
  throw response.rejectException();
});

export const save = async (environmentalLicense) => api.post('/environmental-licenses', environmentalLicense).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});
